/*
 * @Descripttion: 工具函数
 * @Author: zenghua.wang
 * @Date: 2021-04-13 11:19:12
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-04 10:27:11
 */

import lodash from 'lodash'
import moment from 'moment'
import saferEval from 'safer-eval'

/**
 * 深度拷贝对象
 * @param {*} obj
 * @returns
 */
export const deepClone = (obj = {}) => {
  return lodash.cloneDeep(obj)
}

/**
 * 判断是否 empty,返回ture
 * null 'null' undefined 'undefined' 0 '0' "" 返回true
 * @param {*} val
 * @returns
 */
export const isEmpty = (val) => {
  if (val && parseInt(val) === 0) return false
  if (
    typeof val === 'undefined' ||
    val === 'null' ||
    val == null ||
    val === 'undefined' ||
    val === undefined ||
    val === ''
  ) {
    return true
  } else if (typeof val === 'object' && Object.keys(val).length === 0) {
    return true
  } else if (val instanceof Array && val.length === 0) {
    return true
  } else {
    return false
  }
}

/**
 * 比较两个值是否相等
 * @param {*} value
 * @param {*} other
 * @param {*} customizer 用来定制比较值的函数
 * @returns
 */
export const isEqual = (value, other, customizer = lodash.isEqual) => {
  return lodash.isEqualWith(value, other, customizer)
}

/**
 * 修复chrome设置zoom问题
 * @param {*} dom
 */
export const fixChromeZoom = (dom) => {
  if (!dom) return
  if (window.navigator.userAgent.indexOf('Chrome') > 0) {
    if (lodash.isArrayLikeObject(dom)) {
      dom.forEach((item) => {
        item.style.zoom = 1 / window.scale || 1
      })
    } else {
      dom.style.zoom = 1 / window.scale || 1 // inherit
    }
  }
}

/**
 * 恢复chrome默认zoom
 * @param {*} dom
 */
export const getChromeZoom = (dom) => {
  if (!dom) return
  if (window.navigator.userAgent.indexOf('Chrome') > 0) {
    if (dom.length > 1) {
      dom.forEach((item) => {
        item.style.zoom = window.scale
      })
    } else {
      dom.style.zoom = window.scale
    }
  }
}

/**
 * 从数组中随机获取n个元素
 * @param {*} arr
 * @param {*} n
 */
export const getArray = (arr = [], n = 0) => {
  return lodash.sampleSize(lodash.shuffle(arr), n)
}

// 合并数组
export const getArrayByConcat = (...arr) => {
  return lodash.concat([], ...arr)
}

// 数据差集
export const getArrayByExcept = (...arr) => {
  return lodash.xor(...arr)
}

// 数组交集
export const getArrayByIntersection = (...arr) => {
  // return lodash.intersection(...arr)
  return lodash.intersectionWith(...arr, lodash.isEqual)
}

/**
 * 创建id
 * @param {*} prefix
 * @returns
 */
export const createId = (prefix) => {
  let val = Date.now() + Math.ceil(Math.random() * 99999)
  return isEmpty(prefix) ? val + '' : prefix + '-' + val
}

/**
 * 创建UUID
 * @param {*} len
 * @param {*} radix
 * @returns
 */
export const createUUID = (len, radix = 62) => {
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
    ''
  )
  let uuid = []
  radix = radix || chars.length
  if (len) {
    for (let i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
  } else {
    let r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

/**
 * 递归过滤掉arr的每个item包含的temp属性
 * @param {*} arr
 * @returns
 */
export const deleteTempField = (arr = []) => {
  if (arr.length === 0) return arr
  arr.forEach((item) => {
    if (!isEmpty(item)) {
      if (item.temp) delete item.temp
      if (!isEmpty(item.option) && !isEmpty(item.option.column)) {
        item.option.column.forEach((col) => {
          if (col.dicFrom === '动态') {
            col.dicData = []
          }
          if (col.dicFrom === '静态') {
            col.dicUrl = ''
            col.dicMethod = ''
          }
        })
      }
      if (item.children && item.children.length > 0) {
        deleteTempField(item.children)
      }
    }
  })
  return arr
}

/**
 * 递归为arr的每个item新增temp属性
 * @param {*} arr
 * @returns
 */
export const setTempField = (arr = []) => {
  if (arr.length === 0) return arr
  arr.forEach((item) => {
    if (!isEmpty(item)) {
      if (['grid', 'column'].includes(item.type) && isEmpty(item.temp)) {
        item.temp = []
      }
      if (item.children && item.children.length > 0) {
        setTempField(item.children)
      }
    }
  })
  return arr
}

/**
 * 根据category获取模型数据
 * @param {*} category 'report | screen'
 * @param {*} models []
 */
export const getModelsByCategory = (models = [], category = 'report') => {
  let modelList = []
  models.forEach((model) => {
    if (model.category.includes(category)) {
      let list = []
      model.list.forEach((item) => {
        if (item.category.includes(category)) {
          if (!isEmpty(item.width) && Array.isArray(item.width)) {
            let arr = item.width
            item.width = category === 'report' ? arr[0] : arr[1]
          }
          if (!isEmpty(item.height) && Array.isArray(item.height)) {
            let arr = item.height
            item.height = category === 'report' ? arr[0] : arr[1]
          }
          list.push(item)
        }
      })
      model.list = list
      modelList.push(model)
    }
  })
  return modelList
}

/**
 * 将number转换为px
 * @param {*} val
 * @returns
 */
export const setPx = (val, scale = true) => {
  if (isEmpty(val)) return ''
  // val = scale ? val * window.scale || 1 : val
  val = val + ''
  if (val.indexOf('%') === -1) {
    val = val + 'px'
  }
  return val
}

/**
 * 数字获取2位
 * @param {*} val
 * @param {*} len
 * @returns
 */
export const getFixed = (val = 0, len = 2) => {
  return Number(val.toFixed(len))
}

/**
 * 将query{}转为[]
 * @param {*} params
 */
export const getQueryArrByParams = (params) => {
  let arr = []
  if (Object.keys(params).length === 0) return arr
  Object.keys(params).forEach((key) => {
    arr.push({
      label: key,
      value: null
    })
  })
  Object.values(params).forEach((val, index) => {
    arr[index].value = val
  })
  return arr
}

/**
 * 通过获取 ${表达式} 判断按钮的显隐
 * @param {*} ex
 * @returns
 */
export const getShowButtonByExpression = (expr, row = {}, that) => {
  row.loginInfo_id = that.$store.getters.userInfo.subject.id
  row.loginInfo_loginName = that.$store.getters.userInfo.subject.loginName
  if (isEmpty(expr)) return true
  let reg = /\$\{(.+?)\}/g
  let list = []
  let result = null
  // 获取到变量
  do {
    result = reg.exec(expr)
    result &&
      list.push({
        key: result[0], // ${var}
        label: result[1] // var
        // value: row[result[1]]
      })
  } while (result)
  // 替换变量
  if (!isEmpty(list) && !isEmpty(row)) {
    list.forEach((item) => {
      if (Object.keys(row).includes(item.label)) {
        expr = expr.replace(item.key, `row.${item.label}`)
      } else {
        expr = ''
      }
    })
    return !isEmpty(expr)
      ? saferEval(`(function () {return ${expr}})()`, { row })
      : undefined
  }
  return undefined
}

/**
 * 通过获取 ${var} ${var.name} 解析成值
 * @param {*} text
 * @param {*} row
 * @returns
 */
export const getTextByAnalysis = (
  text,
  row = {},
  encode = false,
  column = []
) => {
  if (isEmpty(text)) return ''
  let reg = /\$\{(.+?)\}/g
  let list = []
  let result = null
  // 下拉，级联value转化为label
  const getValue = (label) => {
    let val =
      label.split('.').length > 1
        ? saferEval(`row.${label}`, { row })
        : row[label]
    column.map((col) => {
      if (col.prop === label && ['select', 'cascader'].includes(col.type)) {
        col.dicData.forEach((dic) => {
          if (val === dic.value) {
            val = dic.label
          }
        })
      }
    })
    return val
  }
  // 获取到变量
  do {
    result = reg.exec(text)
    if (result) {
      list.push({
        key: result[0], // ${uuid32}
        label: result[1], // uuid32
        value: getValue(result[1]) // ...
      })
    }
  } while (result)
  // console.log(360, list)
  // 替换变量 text仍然为${var},即变量不在row中
  if (!isEmpty(list) && !isEmpty(row)) {
    list.forEach((item) => {
      let label =
        item.label.split('.').length > 1 ? item.label.split('.')[0] : item.label
      if (Object.keys(row).includes(label)) {
        let value = encode ? encodeURIComponent(item.value) : item.value
        text = text.replace(item.key, value)
      }
    })
  }
  return text
}

/**
 * 将路由里面的参数添加到row里面，解析url
 * @param {*} params
 * @param {*} row
 */
export const setRowByRoute = (params = [], row = {}) => {
  // row参数里面加入uuid
  row.uuid = createUUID()
  row.uuid32 = createUUID(32)
  if (isEmpty(params)) return row
  if (!isEmpty(row)) {
    params.forEach((item) => {
      if (!Object.keys(row).includes(item.label)) {
        row[item.label] = item.value
      }
    })
  } else {
    params.forEach((item) => {
      // if (item.label !== 'id') {
      row[item.label] = item.value
      // }
    })
  }
  return row
}

/**
 * 根据传入的function返回自定义的模板
 * @param {*} fun
 * @param {*} params
 * @param {*} list
 * @returns
 案列：
 let params = { name: '小蓝' }
 let demo = '(function demo(params) { return params.name})(params)'
 let name = saferEval(demo, { params })
 问题：没办法代码验证fun是否是function(){}
 */
export const setTooltipFormatter = (fun, params = {}, list = []) => {
  // console.log(fun, params, list)
  return !isEmpty(fun)
    ? saferEval('(' + fun + ')(params, list)', { params, list })
    : ''
}

/**
 * 根据传入的function字符串语句eval执行
 * @param {*} formatter 方法内语句
 * @param {*} params Object
 * @param {*} self Object vue当前页面this
 * @returns
 */
export const evalFunctionByFormatter = (formatter, params = {}, self = {}) => {
  if (isEmpty(formatter)) return
  let fun = `(function fn(that, params, window) {
    ${formatter}
    // console.log('params=', params, 'this=', that, 'window=', window)
  })(that, params, window)`
  return saferEval(fun, { that: self, params, window })
}

/**
 * 根据条件合并设置值与默认值
 * @param {*} condition
 * @param {*} isprop
 * @param {*} alwaysObj
 * @returns
 */
export const isHasProp = (condition, isprop, alwaysObj) => {
  return Object.assign(
    (() => {
      return condition ? isprop : {}
    })(),
    alwaysObj
  )
}

/**
 * 根据pid递归查找parent
 * @param {*} tree
 * @param {*} pid
 * @returns
 */
export const getParentByPid = (tree = [], pid) => {
  if (isEmpty(tree) || isEmpty(pid)) return null
  let parent = null
  let isFind = false
  function getParentByPid(tree, pid) {
    for (var i = 0; i < tree.length; i++) {
      if (pid === tree[i].id || isFind) {
        isFind || (parent = tree[i])
        isFind = true
        break
      }
      if (!isEmpty(tree[i].children)) {
        getParentByPid(tree[i].children, pid)
      }
    }
  }
  getParentByPid(tree, pid)
  return parent
}

/**
 * 根据value为下拉、级联 广度优先遍历 查找label
 * @param {*} dicData
 * @param {*} val
 */
export const getDictoryByEqual = (dicData = [], val = '') => {
  if (isEmpty(val)) return ''
  let stack = []
  stack = stack.concat(dicData)
  while (stack.length) {
    let temp = stack.shift()
    if (temp.children) {
      stack = stack.concat(temp.children)
    }
    if (temp.label === val || temp.value === val) {
      return temp.label
    }
  }
}

/**
 * 时间格式化
 * @param {*} datetime
 * @param {*} type
 * @returns
 */
export const formatDate2Str = (datetime = new Date(), type = 'YYYY-MM-DD') => {
  return moment(datetime).format(type)
}

export const formatStr2Date = (str) => {
  return moment(str).toDate()
}

/**
 * 获取当前年月日
 * @param {*} type 年(YYYY)/月(MM)/日(DD)
 * @returns
 */
export const getDate = (type) => {
  return parseInt(moment().format(type))
}

/**
 * 获取年(years)、月(months)、日(days)、周(weeks)的上n个时间
 * @param {*} number
 * @param {*} mdate 年(years)/月(months)/日(days)/周(weeks)
 * @param {*} type  如 YYYY-MM-DD"
 * @returns
 */
export const getLastDate = (number, mdate, type) => {
  return moment()
    .subtract(number, mdate)
    .format(type)
}
